import { shallowEqual, useSelector } from 'react-redux';
import { getBonusRefillEvent } from '../selectors';

export const useBonusRefillEvent = () => ({
  bonus: useSelector(getBonusRefillEvent, shallowEqual),
});
